define(function () {
  return [];
});